// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".front[data-v-fc90fa8a]{z-index:2003}.modal-close[data-v-fc90fa8a]{top:-6px}.modal-header[data-v-fc90fa8a]{display:block;padding:0}.modal-header h4[data-v-fc90fa8a]{margin:1em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
